import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import NextApp from 'next/app';
import { CookieConsentContextProvider } from '@grandvisionhq/cookie-consent';
import { getDisplayName } from '@grandvisionhq/utils';

function withConsent(consentProvider) {
    return ()=>{
        return (PageComponent)=>{
            const displayName = getDisplayName(PageComponent);
            const WithConsent = (pageProps)=>{
                return /*#__PURE__*/ React.createElement(CookieConsentContextProvider, {
                    cookies: pageProps.cookies,
                    consentProvider: consentProvider
                }, /*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, pageProps)));
            };
            WithConsent.getInitialProps = function() {
                var _ref = swcHelpers.asyncToGenerator(function*(appContext) {
                    var ref;
                    const inAppContext = Boolean(appContext.ctx);
                    let pageProps = {};
                    if (PageComponent.getInitialProps) {
                        pageProps = yield PageComponent.getInitialProps(appContext);
                    } else if (inAppContext) {
                        pageProps = yield NextApp.getInitialProps(appContext);
                    }
                    var ref1;
                    const cookies = (ref1 = (ref = appContext.ctx.req) === null || ref === void 0 ? void 0 : ref.cookies) !== null && ref1 !== void 0 ? ref1 : {};
                    if (typeof PageComponent.getInitialProps === 'function') {
                        return swcHelpers.objectSpread({}, pageProps, {
                            cookies
                        });
                    }
                    return {
                        cookies
                    };
                });
                return function(appContext) {
                    return _ref.apply(this, arguments);
                };
            }();
            WithConsent.displayName = `WithConsent(${displayName})`;
            return WithConsent;
        };
    };
}

export { withConsent };
//# sourceMappingURL=with-consent.js.map
